export function isDataOption(item) {
    return !!item && "src" in item;
}
export function itemUniqueKey(item) {
    return `${item.src}-${item.id}`;
}
export function containsDataOption(items, item) {
    return item !== null && items.some((i) => itemUniqueKey(i) === itemUniqueKey(item));
}
